// extracted by mini-css-extract-plugin
export default {"Button":"CloseButton_Button__a+RAI","Icon":"CloseButton_Icon__sOy9v"};